import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CommandResponse } from 'src/app/shared/models/command-response';
import { environment } from 'src/environments/environment';
import { TransferinatorRequest } from './models/transferinator-request.model';
import { QueryResponse } from 'src/app/shared/models/query-response';
import { TransferinatorAccountDetailsResponse } from './models/transferinator-account-details.model';
import { AccountTransferIDs } from '../store/support.state';
import { API_URLS } from 'src/app/config/api-urls';
import { CleverAccountLookup } from '../models/clever.model';
import { DeletedAccountLookup } from '../models/undeleter.model';

@Injectable({
  providedIn: 'root',
})
export class SupportApiService {
  private http = inject(HttpClient);

  private cleverAccountsSearchUrl = API_URLS.CLEVER_ACCOUNT_SEARCH;
  private cleverAccountsUpdateUrl = API_URLS.CLEVER_ACCOUNT_UPDATE;
  private undeleterAccountSearchUrl = API_URLS.UNDELETE_ACCOUNT_SEARCH;
  private undeleterStudentRestoreUrl = API_URLS.UNDELETE_STUDENT_RESTORE;

  saveStudentAccountTransfer(model: TransferinatorRequest) {
    return this.http.post<CommandResponse>(
      `${environment.api.hub}/students/transfer`,
      model,
    );
  }

  getTransferinatorAccountDetails(model: {
    accountId: number;
    getStudents: boolean;
  }) {
    return this.http.get<QueryResponse<TransferinatorAccountDetailsResponse>>(
      `${environment.api.hub}/accounts/transferinatorDetails?accountId=${model.accountId}&getStudents=${model.getStudents}`,
    );
  }

  validateAccountLanguageMatch(model: AccountTransferIDs) {
    return this.http.get<QueryResponse<boolean>>(
      `${environment.api.hub}/student?search=${model}`,
    );
  }

  getCleverAccountLookup(accountId: number) {
    const params = new HttpParams().set('accountId', accountId);

    return this.http.get<QueryResponse<CleverAccountLookup>>(
      this.cleverAccountsSearchUrl,
      {
        params,
      },
    );
  }

  updateCleverAccountDetails(
    accountId: number,
    districtName: string,
    ssoReference: string,
    lookupMethod: string,
  ) {
    return this.http.post<QueryResponse>(this.cleverAccountsUpdateUrl, {
      accountId: accountId,
      name: districtName,
      ssoReference: ssoReference,
      lookupMethod: lookupMethod,
    });
  }

  getUndeleterAccountLookup(accountId: number) {
    const params = new HttpParams().set('accountId', accountId);

    return this.http.get<QueryResponse<DeletedAccountLookup>>(this.undeleterAccountSearchUrl, {
      params
    });
  }

  restoreDeletedStudent(accountId: number) {
    return this.http.post<QueryResponse>(this.undeleterStudentRestoreUrl, accountId);
  }
}
